import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  CardOfferExcelSendModal: false,
  storeId: "",
  rewardsId: [],
  totalCount: "",
};

const qubriuxOfferSlice = createSlice({
  name: "qubriuxOffer",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});
export const { updateConfig } = qubriuxOfferSlice.actions;
export default qubriuxOfferSlice.reducer;
